/**
 * Time on Page Tracking
 * Dispara evento time_on_page quando o usuário sai da página.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '@/lib/analytics';
import { Events } from '@/lib/analytics-events';

export function useTimeOnPage(thresholdSeconds = 10) {
  const location = useLocation();
  const startTime = useRef<number>(Date.now());

  useEffect(() => {
    startTime.current = Date.now();

    const handleVisibility = () => {
      if (document.hidden) {
        const elapsed = Math.floor((Date.now() - startTime.current) / 1000);
        if (elapsed >= thresholdSeconds) {
          track(Events.timeOnPage(elapsed, location.pathname));
        }
      }
    };

    const handleBeforeUnload = () => {
      const elapsed = Math.floor((Date.now() - startTime.current) / 1000);
      if (elapsed >= thresholdSeconds) {
        track(Events.timeOnPage(elapsed, location.pathname));
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      const elapsed = Math.floor((Date.now() - startTime.current) / 1000);
      if (elapsed >= thresholdSeconds) {
        track(Events.timeOnPage(elapsed, location.pathname));
      }
    };
  }, [location.pathname, thresholdSeconds]);
}
